module.exports = __webpack_public_path__ + "files/8f0cd274de870578b16bb0eb1da6d392.png";